import * as React from 'react';
import {Select} from 'antd'
import {CustomPagination} from './custom_pagination'
import { LayoutManager } from '../util/layout_manager';
export const Pagination = ({metaData, filterQuery, setFilterQuery}) => {

    return (
        <div
        className='no-wrap-rl-row'
        style={{
            justifyContent: "space-between",
            backgroundColor:'white',
            padding:'16px',
            borderRadius:'4px'
          
        }}
    >
        <div
            className='no-wrap-rl-row'
            style={{
                marginRight: LayoutManager.globalMargin / 2,
            }}
        >
            {/* <div
                className='font-sm gray80'
                style={{
                    marginRight: LayoutManager.globalMargin / 2,
                }}
            >
                View
            </div>
            <Select
                style={{
                    backgroundColor: "transparent",
                }}
                value={filterQuery?.limit ||  20}
                onChange={(v) => {
                    setFilterQuery(prev => ({...prev, limit: v}))
                    // this.setState(
                    //     {
                    //         ...this.state,
                    //         filter_query: {
                    //             ...filter_query,
                    //             page: 1,
                    //             limit: v,
                    //         },
                    //         filter_unsynced_query: {
                    //             ...this.state.filter_unsynced_query,
                    //             limit: v,
                    //             page: 1,
                    //         },
                    //     },
                    //     () => {
                    //         this.state.isUnsyncedList ?
                    //         this.list_unsynced
                    //         .config({
                    //             params: {
                    //                 ...this.state.filter_unsynced_query,
                    //             },
                    //         })
                    //         .execute()  :
                    //         this.list_inactive
                    //             .config({
                    //                 params: {
                    //                     ...this.state.filter_query,
                    //                 },
                    //             })
                    //             .execute();
                    //     }
                    // );
                }}
            >
                {[5, 20, 50, 75, 100].map((lim) => {
                    return (
                        <Select.Option key={lim} value={lim}>
                            {lim}
                        </Select.Option>
                    );
                })}
            </Select> */}
        </div>
        <div
            style={{
                marginRight: 10,
            }}
        >
            <CustomPagination
                meta={metaData}
                onChange={(page, size) => {
                    setFilterQuery(prev => ({...prev, page: page}))
            
                    // this.setState(
                    //     {
                    //         ...this.state,
                    //         filter_query: {
                    //             ...filter_query,
                    //             page: page,
                    //             limit: size,
                    //         },
                    //         filter_unsynced_query: {
                    //             ...this.state.filter_unsynced_query,
                    //             limit: size,
                    //             page: page,
                    //         },
                    //     },
                    //     () => {
                    //         this.state.isUnsyncedList ?
                    //                 this.list_unsynced.config({params: {...this.state.filter_unsynced_query}}).execute()

                            
                    //         : 
                    //         this.list_inactive
                    //             .config({
                    //                 params: {
                    //                     ...this.state.filter_query,
                    //                 },
                    //             })
                    //             .execute();
                    //     }
                    // );
                }}
            />
        </div>
    </div>
    )
}